import React from 'react';
import { connect } from 'react-redux';

import { Button } from 'apps/auth/components/common/Button/Button';
import { FixedBottomPanel } from 'apps/auth/components/common/Layout/FixedBottomPanel/FixedBottomPanel';
import { HeaderPanel } from 'apps/auth/components/common/Layout/HeaderPanel/HeaderPanel';
import InputAutoDetect from 'apps/auth/components/form/InputAutoDetect';
import { getSortFields } from 'apps/auth/components/form-multi/utils';
import { CALCULATOR_SCREEN } from 'apps/auth/components/send/SendConstants';
import { AUTH_GA_POCKET, AUTH_SEND } from 'apps/auth/constants/UrlConstants';
import { toLowerCase } from 'apps/auth/helpers/utils';

const FromFields = (props) => {
    const getVisibleFields = () => {
        let visibleFields = [];
        getSortFields(props.fields).forEach((field) => {
            if (field.visible && field.destination === 'FROM') {
                visibleFields.push(field);
            }
        });
        return visibleFields;
    };

    const href = props.isGA ? `${AUTH_GA_POCKET}${props.pocketId}/send` : AUTH_SEND;

    return (
        <div>
            <HeaderPanel
                title={props.senderDetails}
                buttonRowType="link"
                buttonRowCaption={props.ratesFirst}
                buttonRowHref={`${href}/send/${toLowerCase(props.toCountryCode)}/${toLowerCase(props.toCurrencyCode)}/${props.deliveryMethod}`}
                buttonRowOnClick={(e) => {
                    e.preventDefault();
                    props.setScreen(CALCULATOR_SCREEN);
                }}
            />
            <div className="level-subtop">
                <fieldset>
                    {getVisibleFields().map((field) => {
                        return (
                            <fieldset key={field.name}>
                                <InputAutoDetect formName={props.formName} defaultCountry={props.toCountryCode} field={field} />
                            </fieldset>
                        );
                    })}
                </fieldset>
                <FixedBottomPanel isRightAligned>
                    <Button
                        type="submit"
                        onClick={(e) => {
                            props.checkFieldsAndSubmitFormIfHasNoErrors(e, getVisibleFields());
                        }}
                        raised={true}
                        size="fit"
                        caption={props.continue}
                    />
                </FixedBottomPanel>
            </div>
        </div>
    );
};
const mapStateToProps = (state, ownProps) => {
    return {
        pocketId: state.extra.pocket?.id,
        deliveryMethod: state.extra.deliveryMethod,
        fields: state.form[ownProps.formName]?.fields,
        toCountryCode: state.extra.toCountry?.code,
        toCountryId: state.extra.toCountry?.id,
        toCurrencyCode: state.extra.toCurrency?.code,
        senderDetails: state.messages.pageMessages.senderDetails,
        ratesFirst: state.messages.pageMessages.ratesFirst,
        continue: state.messages.pageMessages.continue,
    };
};
export default connect(mapStateToProps)(FromFields);
